const apiUrls: Record<string, string> = {
  development: "https://api.dev.queenssmile.co.kr/api",
  production: "https://api.partner.queenssmile.co.kr/api",
};

export const config = {
  apiUrl: apiUrls[process.env.REACT_APP_ENV!] ?? apiUrls.development,
};
